import { billExample, MONTHS } from '@/constants/constants';

export const getPaymentInfoDataset = (isBillEntered: boolean, billJsObject: PaymentInfo): EnteredPaymentInfo | null => {
	let jsonLD: PaymentInfo;
	try {
		jsonLD = isBillEntered ? billJsObject : billExample;

		const result: EnteredPaymentInfo = {
			amount: '400.5',
			period: 'Октябрь 2018',
			payer: 'Федорова В.В.',
			address: 'Алтайский край, г. Барнаул, Солнечная поляна, д.43, к.72',
		};

		if (jsonLD.totalPaymentDue) {
			result.amount = jsonLD.totalPaymentDue.price;
		}

		if (jsonLD.customer) {
			result.payer = jsonLD.customer.name;
			result.address = jsonLD.customer.address;
		}

		let period;
		if (jsonLD.billingPeriod) {
			period = new Date(jsonLD.billingPeriod);
			result.period = `${MONTHS[period.getMonth()]} ${period.getFullYear()}`;
		} else {
			result.period = null;
		}

		return result;
	} catch (e) {
		return null;
	}
};
